import { ComponentType, JQueryPlugin } from 'types';

/**
 * If a user adds a resizable component, but does not resize it,
 * it's height is determined by complicated CSS logic, not JS.
 */

export const isCSSHeightMediaComponent = (type: ComponentType): boolean => {
  return cssHeightMediaComponentTypes.includes(type);
};

// These lists are verbatim replacements for awkward scss lists originally located in layout.scss
// I'm just copying it into JS to make it easier to work with.
const cssHeightMediaComponentTypes = [
  ComponentType.ASSET_SELECTOR,
  ComponentType.CLASSIC_VIZ,
  ComponentType.EMBEDDED_HTML,
  ComponentType.MEASURE_CARD,
  ComponentType.MEASURE_CHART,
  ComponentType.CHOROPLETH_MAP,
  ComponentType.REGION_MAP,
  ComponentType.BAR_CHART,
  ComponentType.CALENDAR,
  ComponentType.COLUMN_CHART,
  ComponentType.COMBO_CHART,
  ComponentType.SCATTER_CHART,
  ComponentType.FEATURE_MAP,
  ComponentType.HISTOGRAM,
  ComponentType.MAP,
  ComponentType.TIMELINE_CHART,
  ComponentType.PIE_CHART,
  ComponentType.VIZ_CANVAS,
  ComponentType.YOUTUBE,
];

// For reference, I'll still list out the other component types.
// We don't need these lists anymore, but its helpful to know what the old code was thinking.

// No idea why these particular components were excluded from CSS height treatment.
// We used to need to identify all components that were "media", but not anymore.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const mediaComponentTypes = [
  ComponentType.IMAGE,
  ComponentType.TABLE,
  ComponentType.AG_TABLE,
  ComponentType.STORY_TILE,
  ComponentType.STORY_WIDGET,
];

// And the remaining components that are not considered media components.
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const nonMediaComponentTypes = [
  ComponentType.HTML,
  ComponentType.HTML_TABLE_OF_CONTENTS,
  ComponentType.SPACER,
  ComponentType.HORIZONTAL_RULE,
  ComponentType.GLOBAL_FILTER,
  ComponentType.HERO,
  ComponentType.AUTHOR,
];

export const isMarginTopPluginType = (type: JQueryPlugin): boolean => {
  return marginTopPluginTypes.includes(type);
};

const marginTopPluginTypes = [
  JQueryPlugin.ASSET_SELECTOR,
  JQueryPlugin.AUTHOR,
  JQueryPlugin.IMAGE,
  JQueryPlugin.STORY_TILE,
  JQueryPlugin.MEASURE,
  JQueryPlugin.YOUTUBE,
  JQueryPlugin.INSITU,
  JQueryPlugin.TABLE,
  JQueryPlugin.MAP,
  JQueryPlugin.VIZ_CANVAS,
  JQueryPlugin.EMBEDDED_HTML,
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const nonMarginTopPluginTypes = [
  JQueryPlugin.HTML,
  JQueryPlugin.SPACER,
  JQueryPlugin.HORIZONTAL_RULE,
  JQueryPlugin.GLOBAL_FILTER,
  JQueryPlugin.HERO,
];
